import { groupBy, PublishedDocPageVisitsEntry } from "@supernova-studio/model";
import { DTODocumentationAnalyticsTimeFrame, DTOPublishedDocVisitHeatMapWeek } from "../../dto";

export function documentationAnalyticsToHeatMapDto(
  entries: PublishedDocPageVisitsEntry[],
  timeFrame: DTODocumentationAnalyticsTimeFrame
): DTOPublishedDocVisitHeatMapWeek {
  const byWeekDay = groupBy(entries, e => e.timestamp.getUTCDay());

  return {
    timeFrame,
    mon: entriesToHeatmapDay(byWeekDay.get(1)),
    tue: entriesToHeatmapDay(byWeekDay.get(2)),
    wed: entriesToHeatmapDay(byWeekDay.get(3)),
    thu: entriesToHeatmapDay(byWeekDay.get(4)),
    fri: entriesToHeatmapDay(byWeekDay.get(5)),
    sat: entriesToHeatmapDay(byWeekDay.get(6)),
    sun: entriesToHeatmapDay(byWeekDay.get(7)),
  };
}

function entriesToHeatmapDay(entries: PublishedDocPageVisitsEntry[] | undefined): number[] {
  const byHour = groupBy(entries ?? [], e => e.timestamp.getUTCHours());

  return [
    sumVisits(byHour.get(0), byHour.get(1)), // 0am-2am
    sumVisits(byHour.get(2), byHour.get(3)), // 2am-4am
    sumVisits(byHour.get(4), byHour.get(5)), // 4am-6am
    sumVisits(byHour.get(6), byHour.get(7)), // 6am-6am
    sumVisits(byHour.get(8), byHour.get(9)), // 8am-6am
    sumVisits(byHour.get(10), byHour.get(11)), // 10am-12pm
    sumVisits(byHour.get(12), byHour.get(13)), // 12pm-2pm
    sumVisits(byHour.get(14), byHour.get(15)), // 2pm-4pm
    sumVisits(byHour.get(16), byHour.get(17)), // 4pm-6pm
    sumVisits(byHour.get(18), byHour.get(19)), // 6pm-8pm
    sumVisits(byHour.get(20), byHour.get(21)), // 8pm-10pm
    sumVisits(byHour.get(22), byHour.get(23)), // 10pm-12pm
  ];
}

function sumVisits(...entryArrays: (PublishedDocPageVisitsEntry[] | undefined)[]) {
  let sum = 0;

  entryArrays.forEach(a => {
    a?.forEach(e => (sum += e.visits));
  });

  return sum;
}
